(function () {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    // ----- gallery -----
    var track = root.querySelector('[data-dpp-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-dpp-thumb]'));
    var thumbViewport = root.querySelector('[data-dpp-thumbs]');
    var index = 0;
    function go(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + index * -100 + '%)';
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === index); });
      var t = thumbs[index];
      if (t && thumbViewport) {
        var left = t.offsetLeft - (thumbViewport.clientWidth - t.offsetWidth) / 2;
        thumbViewport.scrollTo({ left: Math.max(0, left) });
      }
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.dppThumb, 10)); }); });
    var prev = root.querySelector('[data-dpp-prev]'), next = root.querySelector('[data-dpp-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    if (track) {
      var sx = null, sy = null;
      track.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
      track.addEventListener('pointerup', function (e) {
        if (sx === null) return;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(index + (dx < 0 ? 1 : -1));
        sx = null;
      });
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    // ----- variant -----
    var variant = root.querySelector('[data-dpp-variant]');
    var priceBox = root.querySelector('[data-dpp-price]');
    var atc = root.querySelector('[data-dpp-atc]');
    var promo = priceBox && priceBox.querySelector('.dpp__badge--promo');
    var promoText = promo ? promo.textContent : '';
    if (variant) {
      variant.addEventListener('change', function () {
        var o = variant.options[variant.selectedIndex];
        var html = '';
        if (o.dataset.compare) html += '<s class="dpp__compare">' + o.dataset.compare + '</s>';
        html += '<span class="dpp__sale">' + o.dataset.price + '</span>';
        if (o.dataset.save) {
          html += '<span class="dpp__badge dpp__badge--save">Save ' + o.dataset.save + '%</span>';
          if (promoText) html += '<span class="dpp__badge dpp__badge--promo">' + promoText + '</span>';
        }
        priceBox.innerHTML = html;
        if (atc) atc.disabled = o.dataset.available !== 'true';
        if (o.dataset.media) {
          var n = slides.findIndex(function (s) { return s.dataset.mediaId === o.dataset.media; });
          if (n > -1) go(n);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', o.value);
        window.history.replaceState({}, '', url.toString());
      });
    }

    // ----- quantity -----
    var qty = root.querySelector('.dpp__qty-input');
    root.querySelectorAll('[data-dpp-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.dppQty, 10));
        qty.value = v;
      });
    });

    // ----- tabs -----
    root.querySelectorAll('[data-dpp-tab]').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = document.getElementById(b.getAttribute('aria-controls'));
        var open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', open ? 'false' : 'true');
        c.hidden = open;
      });
    });

    // ----- pop-ups -----
    var lastFocus = null;
    function openLayer(el) { lastFocus = document.activeElement; el.hidden = false; document.body.classList.add('dpp-lock'); var c = el.querySelector('button'); if (c) c.focus(); }
    function closeLayer(el) { if (!el || el.hidden) return; el.hidden = true; document.body.classList.remove('dpp-lock'); if (lastFocus) lastFocus.focus(); }
    var full = root.querySelector('[data-dpp-full]');
    if (full) {
      document.body.appendChild(full);
      root.querySelectorAll('[data-dpp-full-open]').forEach(function (b) { b.addEventListener('click', function () { openLayer(full); }); });
      full.querySelector('[data-dpp-full-close]').addEventListener('click', function () { closeLayer(full); });
      full.addEventListener('click', function (e) { if (e.target === full) closeLayer(full); });
    }
    var video = root.querySelector('[data-dpp-video]');
    var player = video && video.querySelector('[data-dpp-video-player]');
    if (video) {
      document.body.appendChild(video);
      root.querySelectorAll('[data-dpp-reel]').forEach(function (b) {
        b.addEventListener('click', function () {
          player.src = b.dataset.dppReel;
          openLayer(video);
          var p = player.play(); if (p && p.catch) p.catch(function () { player.muted = true; player.play().catch(function () {}); });
        });
      });
      function closeVideo() { player.pause(); player.removeAttribute('src'); player.load(); closeLayer(video); }
      video.querySelector('[data-dpp-video-close]').addEventListener('click', closeVideo);
      video.addEventListener('click', function (e) { if (e.target === video) closeVideo(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !video.hidden) closeVideo(); });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && full && !full.hidden) closeLayer(full); });

    // reel previews play while visible
    var previews = root.querySelectorAll('[data-dpp-preview]');
    function play(v) { if (!v.src) v.src = v.dataset.src; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) play(e.target); else e.target.pause(); });
      });
      previews.forEach(function (v) { io.observe(v); });
    } else previews.forEach(play);

    // remember for "Recently viewed"
    try {
      var handle = window.location.pathname.split('/products/')[1];
      if (handle) {
        handle = decodeURIComponent(handle.split('/')[0].split('?')[0]);
        var list = JSON.parse(localStorage.getItem('dp-recently-viewed') || '[]').filter(function (h) { return h !== handle; });
        list.unshift(handle);
        localStorage.setItem('dp-recently-viewed', JSON.stringify(list.slice(0, 12)));
      }
    } catch (e) {}
  }
  document.querySelectorAll('[data-dpp]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-dpp]').forEach(init); });
})();
